<template>
  <div>
    <Menu v-bind="this.$attrs" @openMenu="openMenu" @closeMenu="closeMenu">
      <slot></slot>
    </Menu>
  </div>
</template>

<script>
import Menu from './Menu.vue';

export default {
  name: 'slide',
  components: {
    Menu
  },
  methods: {
    openMenu() {
      this.$emit('openMenu');
    },
    closeMenu() {
      this.$emit('closeMenu');
    }
  }
};
</script>
